import packageJson from '../../package.json';

export const environment = {
  production: false,
  APP_NAME: 'SiteConnect',
  SERVICE_URL: 'https://api.staging.siteconnect.io/',
  LARAVEL_API_URL: 'https://api.staging.siteconnect.io/api/v1/',
  API_URL: 'https://api.staging.siteconnect.io/api/',
  MODE: 'STAGING',
  APP_VERSION: packageJson.version,
  PROJECT_KNOWLEDGEBASE_URL: 'https://docs.sitesoft.com/',
  PROJECT_RELEASE_NOTES_URL: 'https://siteconnect.io/release-notes/',
  ANDROID_STORE_URL_MOBILE: 'https://play.google.com/store/apps/details?id=com.sitesoft.crm',
  ANDROID_STORE_URL_KIOSK: 'https://play.google.com/store/apps/details?id=com.sitesoft.geotab',
  IOS_STORE_URL_MOBILE: 'https://apps.apple.com/us/app/siteconnect/id1375246319',
  IOS_STORE_URL_KIOSK: 'https://apps.apple.com/us/app/siteconnect-visitor-kiosk/id1436775925',
  SALES_EMAIL: 'sales@sitesoft.com',
  SUPPORT_EMAIL: 'support@sitesoft.com',
  COMPANY_ADDRESS: `Level 11, 19 Como Street\nTakapuna\nAuckland, 0622\nNew Zealand`,
  SALES_PHONE: '+64 800 748 763',
  SHOW_MAP: true,
  MAP_IFRAME_URL: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3195.252144951165!2d174.76702461529692!3d-36.78850448384448!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d0d39d6d92c8b49%3A0x15282ad97c7503e1!2s19+Como+St%2C+Takapuna%2C+Auckland+0622!5e0!3m2!1sen!2snz!4v1527731028188',
  AES_STORAGE_KEY: '!w5ZS*0=J\'e6px]o/lUXO_^ku#9EfF',
  PRIVACY_POLICY_URL: 'https://www.sitesoft.com/privacy-policy/',
  TERMS_CONDITIONS_URL: 'https://www.sitesoft.com/terms/',
  URGENT_NOTICE_URL: 'https://docs.sitesoft.com/',
  GOOGLE_ANALYTICS: {
    MEASUREMENT_ID: 'G-4FBCQ6VBCV'
  },
  // HubSpot portal id for the live chat widget. Leave null to disable the widget.
  HUBSPOT_PORTAL_ID: null,
  UPVOTY_LINK: 'https://roadmap.siteconnect.io/',
  SENTRY_DSN: 'https://44603156fb2df702628d1726319559d9@o4509041843699712.ingest.us.sentry.io/4509149943169024',
  SENTRY_ENVIRONMENT: 'staging',
  SENTRY_RELEASE: 'siteconnect-web@'+packageJson.version,
  SENTRY_TRACES_SAMPLE_RATE: 0.1,
  SENTRY_REPLAYS_SESSION_SAMPLE_RATE: 0.1,
  SENTRY_ON_ERROR_SAMPLE_RATE: 0.1,
  GOOGLE_MAPS_API_KEY: 'AIzaSyCL3mSC4P1CDk6sgTXlPSJ-o3q3blInIuM',
  TINYMCE_API_KEY: 'wf31dw56naqfmfyhg4y9iodit40djg22piyheervj3kr8xcm',
  DEFAULT_COUNTRY_CODE: 'nz',
  DEFAULT_CURRENCY_CODE: 'NZD'
};
